import './AppOutlets/index';
import './AppOutlets/custom';
import './SdkInit';
import {getOutlet} from 'reconnect.js';
import * as AppActions from './AppActions/index';
import * as CustomActions from './AppActions/custom';

const ActionOutlet = getOutlet('actions');

ActionOutlet.update({
  ...AppActions,
  ...CustomActions,
});

//TODO: for debug
if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
}

console.log('App initialized');
